"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidEvmAddress = isValidEvmAddress;
exports.isValidTronAddress = isValidTronAddress;
exports.isValidAddress = isValidAddress;
const sha3_js_1 = require("@noble/hashes/sha3.js");
const sha2_js_1 = require("@noble/hashes/sha2.js");
const utils_js_1 = require("@noble/hashes/utils.js");
const BASE58 = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
/** Bitcoin-style base58 decode. Returns null on any character outside the alphabet. */
function base58Decode(input) {
    const bytes = [0];
    for (const char of input) {
        const value = BASE58.indexOf(char);
        if (value === -1)
            return null;
        let carry = value;
        for (let i = 0; i < bytes.length; i += 1) {
            carry += bytes[i] * 58;
            bytes[i] = carry & 0xff;
            carry >>= 8;
        }
        while (carry > 0) {
            bytes.push(carry & 0xff);
            carry >>= 8;
        }
    }
    for (let i = 0; i < input.length && input[i] === '1'; i += 1)
        bytes.push(0);
    return Uint8Array.from(bytes.reverse());
}
function toHex(bytes) {
    let out = '';
    for (const byte of bytes)
        out += byte.toString(16).padStart(2, '0');
    return out;
}
/** EIP-55: upper-case the hex digit when the matching keccak nibble is >= 8. */
function checksumEvm(lower) {
    const hash = toHex((0, sha3_js_1.keccak_256)((0, utils_js_1.utf8ToBytes)(lower)));
    let out = '';
    for (let i = 0; i < lower.length; i += 1) {
        out += parseInt(hash[i], 16) >= 8 ? lower[i].toUpperCase() : lower[i];
    }
    return out;
}
/**
 * A 20-byte hex address. An all-lowercase or all-uppercase body has no checksum to verify and is
 * accepted; a mixed-case body must satisfy EIP-55, which is what catches a mistyped character.
 */
function isValidEvmAddress(value) {
    const address = value.trim();
    if (!/^0x[0-9a-fA-F]{40}$/.test(address))
        return false;
    const body = address.slice(2);
    if (body === body.toLowerCase() || body === body.toUpperCase())
        return true;
    return body === checksumEvm(body.toLowerCase());
}
/** Base58Check over 21 bytes that start with 0x41, with a double-sha256 four-byte checksum. */
function isValidTronAddress(value) {
    const address = value.trim();
    if (!/^T[1-9A-HJ-NP-Za-km-z]{33}$/.test(address))
        return false;
    const decoded = base58Decode(address);
    if (!decoded || decoded.length !== 25 || decoded[0] !== 0x41)
        return false;
    const expected = (0, sha2_js_1.sha256)((0, sha2_js_1.sha256)(decoded.subarray(0, 21))).subarray(0, 4);
    return decoded.subarray(21).every((byte, index) => byte === expected[index]);
}
function isValidAddress(chainType, value) {
    return chainType === 'tron' ? isValidTronAddress(value) : isValidEvmAddress(value);
}
//# sourceMappingURL=address.js.map